// HTML DOM and SVG DOM may have different support levels,
// so we need to check on context instead of a document root element.
export function contains(context: Element, node: Element) {
  if (context.contains) return context.contains(node);

  if (context.compareDocumentPosition) return context === node || Boolean(context.compareDocumentPosition(node) & 16);

  return null;
}
